import { IProductRepository } from './interfaces/IProductRepository';
import { IBranchRepository } from './interfaces/IBranchRepository';
import { IBrandRepository } from './interfaces/IBrandRepository';
import { MockProductRepository } from './mock/MockProductRepository';
import { MockBranchRepository } from './mock/MockBranchRepository';
import { MockBrandRepository } from './mock/MockBrandRepository';
import { ApiProductRepository } from './api/ApiProductRepository';
import { ApiBranchRepository } from './api/ApiBranchRepository';
import { ApiBrandRepository } from './api/ApiBrandRepository';

/**
 * Factory Pattern para crear instancias de repositories.
 * 
 * Usa la variable de entorno VITE_USE_MOCK_DATA para determinar
 * si usar Mock (data dummy) o API (Supabase).
 * 
 * Por defecto usa Mock si la variable no está definida.
 */

const USE_MOCK = import.meta.env.VITE_USE_MOCK_DATA === 'true';

// Singleton instances
let productRepo: IProductRepository | null = null;
let branchRepo: IBranchRepository | null = null;
let brandRepo: IBrandRepository | null = null;

/**
 * Obtiene la instancia singleton del Product Repository
 */
export const getProductRepository = (): IProductRepository => {
    if (!productRepo) {
        productRepo = USE_MOCK
            ? new MockProductRepository()
            : new ApiProductRepository();

        if (import.meta.env.DEV) {
            console.log(`[Repository Factory] Using ${USE_MOCK ? 'Mock' : 'API'} Product Repository`);
        }
    }
    return productRepo;
};

/**
 * Obtiene la instancia singleton del Branch Repository
 */
export const getBranchRepository = (): IBranchRepository => {
    if (!branchRepo) {
        branchRepo = USE_MOCK
            ? new MockBranchRepository()
            : new ApiBranchRepository();

        if (import.meta.env.DEV) {
            console.log(`[Repository Factory] Using ${USE_MOCK ? 'Mock' : 'API'} Branch Repository`);
        }
    }
    return branchRepo;
};

/**
 * Obtiene la instancia singleton del Brand Repository
 */
export const getBrandRepository = (): IBrandRepository => {
    if (!brandRepo) {
        // TODO: Switch to API implementation when backend is ready for brands
        brandRepo = new MockBrandRepository();
        // USE_MOCK
        // ? new MockBrandRepository()
        // : new ApiBrandRepository();

        if (import.meta.env.DEV) {
            console.log(`[Repository Factory] Using Mock Brand Repository (Forced)`);
        }
    }
    return brandRepo;
};

/**
 * Resetea todas las instancias (útil para testing)
 */
export const resetRepositories = (): void => {
    productRepo = null;
    branchRepo = null;
    brandRepo = null;
};
